import Nav from 'react-bootstrap/Nav';

import {FaRegWindowRestore, FaRegWindowMaximize, FaRegWindowMinimize, FaRegWindowClose, FaClone} from 'react-icons/fa';
// reimport these if you want to use the change window location functions: FaAngleDoubleDown, FaAngleDoubleLeft,

interface TabValues {
  name: string;
  desc: string;
  //show: boolean;
  icon: JSX.Element;
}

export interface MyComponentProps {
  availableTabs: TabValues[],
  handleTabChange: any,
  windowLoad: any
  windowId: string,
  openWidthHeight: string,
  handleClose: any
  handleMinimize: any
  handleMaximize: any
  handleMiddlize: any
  handleDuplicateWindow: any
  windowType: string
  altWindowState: boolean
  // Define your prop types here
}
export const WindowNavBar: React.FC<MyComponentProps> = ({availableTabs, handleTabChange, windowLoad, windowId, openWidthHeight, handleClose, handleMinimize, handleMaximize, handleMiddlize, handleDuplicateWindow, windowType, altWindowState}) => {

  const displayTabs = () => {
    const tabs = availableTabs && availableTabs.map((t) => {
        return (
          <Nav.Item key={"tab-" + t.name}>
            <Nav.Link active={windowLoad === t.name} title={t.desc} onClick={() => {handleTabChange(t.name)}}>{t.icon}</Nav.Link>
          </Nav.Item>
        )
    })
    return tabs
  }
  return (
  <Nav variant="tabs">
    {displayTabs()}
  

  {openWidthHeight !== "min" &&
  <Nav.Item>
    <Nav.Link title="Minimize Window" onClick={() => {handleMinimize(windowId)}}><FaRegWindowMinimize/></Nav.Link>
  </Nav.Item>}
  {openWidthHeight !== "middle" &&
  <Nav.Item>
    <Nav.Link title="Half Size Window" onClick={() => {handleMiddlize(windowId)}}><FaRegWindowRestore/></Nav.Link>
  </Nav.Item>
  }
  {openWidthHeight !== "max" &&
  <Nav.Item>
    <Nav.Link title="Maximize Window" onClick={() => {handleMaximize(windowId)}}><FaRegWindowMaximize/></Nav.Link>
  </Nav.Item>
  }
  {windowId !== "window1"
  &&
  <Nav.Item>
    <Nav.Link title="Close Window" onClick={() => {handleClose(windowId)}}><FaRegWindowClose/></Nav.Link>
  </Nav.Item>
  }
  {/* commented to prevent window moving; this insures window 1 is always side window and window 2 is bottom window
    uncomment if this behavior is desired
    <Nav.Item>
    <Nav.Link title="Move Window" onClick={() => {props.handleSwitchWindow(props.windowId, props.windowType)}}>{props.windowType === "sideWindow" ? <FaAngleDoubleDown/> : <FaAngleDoubleLeft/>}</Nav.Link>
  </Nav.Item>
  */
  }
  <Nav.Item>
    {!altWindowState && <Nav.Link title="Clone Window" onClick={() => {handleDuplicateWindow(windowId, windowType)}}>{<FaClone/>}</Nav.Link>}
  </Nav.Item>


</Nav>

  );
}

